var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullWidth"},[(_vm.scene && _vm.showFPS)?_c('p',{staticStyle:{"position":"fixed","left":"10px","top":"10px"}},[_vm._v(_vm._s('FPS: ' + _vm.scene.FPS))]):_vm._e(),_c('canvas',{attrs:{"id":"scene"}})])}
var staticRenderFns = []

export { render, staticRenderFns }